import { transport } from 'config/transport';

export function callApiSaveAsset(congDoanId, academicYear, body) {
    return transport.post(`congDoan/${congDoanId}/assets`, body, { params: { academicYear } });
}
